export function getConditionModifier(condition?: unknown): string {
	return typeof condition === 'string' && condition.length ? `--${condition}Condition` : '';
}
